<template>
    <div class="flexCen">
        <img src="@/assets/images/common/error-404.jpg" alt="">
        <router-link to="/index"><el-button class="goback">返回首页</el-button></router-link>
    </div>
</template>

<script>
    export default {
        name: "Error-404",
        data() {
            return {}
        },
        creatd() {
        },
        mounted() {
        },
        methods: {},
        components: {}

    }
</script>

<style lang="scss" scoped>
.flexCen{
    text-align: center;
    padding-top:10%;
    a{
        text-decoration: none;
    }
    .goback{
        display: block;
        margin: 0 auto;
    }
}
</style>